const {TableStore} = require('./tableStore');
const {BlobStore} = require('./blobStore');
const {QueueStore} = require('./queueStore');
const {getAccountDetailsFromConnectionString} = require('./utils/connectionStringParser');

module.exports = {QueueStore, TableStore, BlobStore, getAccountDetailsFromConnectionString};